import { render } from "./ProjectSummaryTable.vue?vue&type=template&id=8e1601d8&scoped=true"
import script from "./ProjectSummaryTable.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryTable.vue?vue&type=script&lang=js"

import "./ProjectSummaryTable.vue?vue&type=style&index=0&id=8e1601d8&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e1601d8"]])

export default __exports__